import services from './services';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import areaSelect from 'area-select';

export default {
    mixins: [services],
    components: {
        'area-select': areaSelect
    },
    data() {
        return {
            transportList: [],
            PayList: [],
            areaDisabled: false,
            dialogVisible: true,
            OrderData: {},
            areaInfo: this.getAreaInfo(),
            AddAddress: {},
            picVisible: false,
            picUrl: ""
        }
    },
    props: {
        Id: {
            default: ""
        },
        isUpdate: {
            default: false
        }
    },
    methods: {
        isShowStartEndTime(value) {
            if (value == "至") {
                return false;
            }
            return true;
        },
        isValLengthMore0(value) {
            if (Object.prototype.toString.call(value) === "[object Array]") {
                if (value.length > 0) {
                    return true;
                }
            }
            if ($.trim(value).length > 0) {
                return true;
            }
            return false;
        },
        viewpic(val) {
            this.picVisible = true;
            this.picUrl = val;
        },
        goback() {
            this.$emit("showpage");
        },
        getAreaInfo() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            });
        },
        updateFn() {

            let areaselectObj = this.$refs.areaSelect.validate();

            let flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "联系方式",
                    value: this.OrderData.ConsigneeTel,
                    phone: true
                }]
            });
            if (!flag) {
                return;
            }
            if (!areaselectObj) {
                return;
            }
            this.OrderData.ProvincesId = areaselectObj.Provinces_Id;
            this.OrderData.CityId = areaselectObj.City_Id;
            this.OrderData.AreaId = areaselectObj.Area_Id;
            this.updateOrderData();
        }
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        },
        showByOrderType() {
            // SO  GK
            let orderType = $.trim(this.OrderData.OrderType);
            if (orderType.indexOf("SO") > -1 || orderType.indexOf("GK") > -1 || orderType.indexOf("SU") > -1) {
                return false;
            }
            return true;
        },
        isShowGk() {
            let orderType = $.trim(this.OrderData.OrderType);
            if (orderType.indexOf("GK") > -1) {
                return true;
            }
            return false;
        }
    },
    mounted() {
        this.getPay(8);
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/components/viewtestclass/vm.js